import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import AtividadesService from '../services/AtividadesService';
import AgendaService from '../services/AgendaService';
import LoaderService from '../services/LoaderService';
import WeexModal from '../comps/weexModais/WeexModal';
import CardNovosHabitos from '../comps/CardNovosHabitos'
import { AnimateOnChange } from 'react-animation'
import {useStore} from 'react-redux';

function NovosHabitos() {
    const css = {
        width: "100%"
    }
    const i18n = useStore().getState().i18n; 
    const history = useHistory()
    let {codigo, codigoAtividade} = useParams()
    const atividadesService = new AtividadesService()
    const agendaService = new AgendaService()
    const loaderService = new LoaderService()
    const [processando, setProcessando] = useState(false)
    const [erro, setErro] = useState(null)
    const [novoHabito, setNovoHabito] = useState()
    const [indiceNovoHabito, setIndiceNovoHabito] = useState(-1)
    const [marcadorProgresso, setMarcadorProgresso] = useState()
    const [primeiraExecucao, setPrimeiraExecucao] = useState(true)
    const [atividade, setAtividade] = useState()

    useEffect(() => {
        if(!processando){
            setProcessando(true)
            atividadesService.iniciarAtividade(codigo, codigoAtividade, (erro, atividade) => {
                if(atividade){
                    if(atividade.dateFinished !== null){
                        agendaService.atualizarAgenda(codigo, codigoAtividade, "NEW_HABIT", atividade.newHabit.cards.length, atividade.score, (erro, sucesso) => {
                            if(sucesso){
                                setPrimeiraExecucao(false)
                            } else if(erro){
                                setErro({
                                    titulo: i18n.message("dinamica.erro.jaexecutada.titulo", "Erro ao exibir atividade já executada"), 
                                    mensagem: i18n.message("dinamica.erro.jaexecutada.mensagem", "Falha ao atualizar informações de atividade executadas, entre em contato com o suporte"), 
                                    voltarAgenda: true})
                            }
                        })
                    }
                    setNovoHabito(atividade.newHabit)
                    setAtividade(atividade)
                    atividade.newHabit.theme.css = {background: atividade.newHabit.theme.backgroundColor, color: atividade.newHabit.theme.foregroundColor}
                    let dimensoes = (atividade.newHabit.cards.length < 10 ? 4 : 40/atividade.newHabit.cards.length) + "vw"
                    if(atividade.newHabit.cards.length > 1){
                        loaderService.load(atividade.newHabit.cards[1].picture)
                    }
                    let progresso = atividade.newHabit.cards.map((a, i) => {
                        return indiceNovoHabito >= 0 ? (
                                                        (i <= indiceNovoHabito) ? (<div className="marcador marcador-concluido" style={{width: dimensoes, height: dimensoes}} key={i}></div>) :
                                                        (<div className="marcador" style={{width: dimensoes, height: dimensoes}} key={i}></div>)
                                                        ):
                                                        null

                    })
                    setMarcadorProgresso(progresso)
                }
                if(erro){
                    if (erro.response && erro.response.data && erro.response.data.message) {
                        setErro({
                            titulo: i18n.message("dinamica.erro.iniciar.titulo", "Erro ao iniciar atividade"), 
                            mensagem: erro.response.data.message, voltarAgenda: true})
                    } else {
                        setErro({
                            titulo: i18n.message("dinamica.erro.iniciar.titulo", "Erro ao iniciar atividade"), 
                            mensagem: i18n.message("dinamica.erro.iniciar.mensagem", "Entre em contato com o suporte ou tente novamente mais tarde."), 
                            voltarAgenda: true})
                    }
                }
            })
        }
    }, []);

    const callbackModal = () => {
        setErro(null)
        if(erro.voltarAgenda){
            history.push("/atividades")
        }
    }

    const finalizar = () => {
        if(primeiraExecucao){
            atividadesService.finalizarAtividade(codigo, codigoAtividade, "NEW_HABIT", {}, (erro, atividade) => {
                if(atividade){
                    history.push('/missionFinished/' + codigo + '/NEW_HABIT/' + codigoAtividade)
                }
                if(erro){
                    if (erro.response && erro.response.data && erro.response.data.message) {
                        setErro({
                            titulo: i18n.message("dinamica.erro.finalizar.titulo", "Erro ao finalizar atividade"), 
                            mensagem: erro.response.data.message, voltarAgenda: false})
                    } else {
                        setErro({
                            titulo: i18n.message("dinamica.erro.finalizar.titulo", "Erro ao finalizar atividade"), 
                            mensagem: i18n.message("dinamica.erro.finalizar.mensagem", "Entre em contato com o suporte ou tente novamente mais tarde."), 
                            voltarAgenda: false})
                    }
                }
            })
        } else {
            atividadesService.finalizarAtividade(codigo, codigoAtividade, "NEW_HABIT", {}, (erro, sucesso) => {
                if(sucesso){
                    history.push('/missionFinished/' + codigo + '/NEW_HABIT/' + codigoAtividade)
                } else if(erro){
                    setErro(
                        {
                            titulo: i18n.message("dinamica.erro.finalizar.titulo", "Erro ao finalizar atividade"), 
                            mensagem: i18n.message("dinamica.erro.finalizar.mensagem", "Falha ao atualizar informações de atividade executadas, entre em contato com o suporte"), 
                            voltarAgenda: false})
                }
            })
        }
    }

    const proximoCard = () => {
        let indice = indiceNovoHabito + 1
        if(indice === novoHabito.cards.length){
            return
        }
        if(novoHabito.cards.length > indice + 1){
            loaderService.load(novoHabito.cards[indice + 1].picture)
        }
        setIndiceNovoHabito(indice)
        let dimensoes = (atividade.newHabit.cards.length < 10 ? 4 : 40/atividade.newHabit.cards.length) + "vw"
        let progresso = novoHabito.cards.map((a, i) => {
            return (i <= indice) ? (<div className="marcador marcador-concluido" style={{width: dimensoes, height: dimensoes}} key={i}></div>) :
                                            (<div className="marcador" style={{width: dimensoes, height: dimensoes}} key={i}></div>)
        })
        setMarcadorProgresso(progresso)
    }

    return (
        <div>
            {erro != null ? (
                <WeexModal callback={callbackModal} visivel={erro != null} titulo={erro.titulo} conteudo={erro.mensagem}/>
            ) : null}
            <div className="fato-fake-container">
                <AnimateOnChange style={css}>
                    {novoHabito != null ? (
                        <div>
                            <CardNovosHabitos ultimo={indiceNovoHabito >= (novoHabito.cards.length - 1)} novoHabito={novoHabito} card={indiceNovoHabito >= 0 ? (novoHabito.cards[indiceNovoHabito]) : null} theme={novoHabito.theme} proximoHabito={proximoCard} finalizar={finalizar}></CardNovosHabitos>
                            
                            <div className="marcador-progresso">
                                {marcadorProgresso}
                            </div>
                        </div>
                    ) : (null)}
                </AnimateOnChange>
            </div>
        </div>
    )
} 

export default NovosHabitos;